import { render } from "./ProfileComments.vue?vue&type=template&id=ab0ffb66"
import script from "./ProfileComments.vue?vue&type=script&lang=js"
export * from "./ProfileComments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__